import React from 'react';

import { Pill, SelectField } from '@/components';
import { Nullable } from '@/types';
import { DataDef, DataDefProps } from '../types';

export function enumValue<E, O, T extends Record<string, any>>({
  field,
  title,
  e,
  filterField,
  isMulti,
  getValue,
  labelMap = {},
  ...rest
}: DataDefProps<O, T> & {
  e: Record<string, E>;
  filterField?: string;
  isMulti?: boolean;
  labelMap?: Record<string, Nullable<string>>;
}): DataDef<O, T> {
  return {
    title,
    field,
    component: ({ row }) => {
      const value = getValue ? getValue({ row }) : row[field];
      return <>{value ?? '-'}</>;
    },
    ...rest,
    filter: filterField
      ? {
          field,
          transformDefaultValues: (values) => {
            const val = values[filterField];
            if (isMulti) {
              return { ...values, [filterField]: val || [] };
            }
            return { ...values, [filterField]: val || '' };
          },
          transformValues: (values) => {
            const val = values[filterField];

            return {
              ...values,
              [filterField]: val && val.length > 0 ? val : undefined,
            };
          },
          component: () => (
            <SelectField
              title={title}
              name={filterField}
              id={filterField}
              isMulti={isMulti}
              options={Object.keys(e).map((value) => ({
                value,
                label: labelMap[value] ?? value,
              }))}
            />
          ),
          pillView: (values, updateFilter) => {
            const value = values[filterField];
            if (value) {
              if (value instanceof Array) {
                return (
                  <>
                    {value.map((val) => (
                      <Pill
                        key={val}
                        onClick={() =>
                          updateFilter({
                            [filterField]: value.filter((v) => v !== val),
                          })
                        }
                      >
                        {labelMap[val] ?? val}
                      </Pill>
                    ))}
                  </>
                );
              }

              return (
                <Pill
                  onClick={() =>
                    updateFilter({
                      [filterField]: undefined,
                    })
                  }
                >
                  {labelMap[value] ?? value}
                </Pill>
              );
            }
            return null;
          },
        }
      : undefined,
  };
}
